module.exports = __webpack_public_path__ + "mannyandme.png?d58d1edea32af84873cabffd0eb49256";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/mannyandme.png
// module id = 120
// module chunks = 0